import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { QboLink, QboSimpleDataTable } from '@ui/Components';
import { Pagination } from '@mui/material';

const initialPagination = {
  pageIndex: 0,
  pageSize: 5,
};

export default function TableConfirmationBlock({ title, headers, list }) {
  const [visible, setVisible] = useState(false);
  const [pagination, setPagination] = useState(initialPagination);

  const paginatedList = useMemo(() => {
    const start = pagination.pageIndex * pagination.pageSize;
    const end = start + pagination.pageSize;
    return list.slice(start, end);
  }, [list, pagination]);

  const showPagination = list.length > paginatedList.length;

  const handleChangePage = (_, newPage) =>
    setPagination({
      ...pagination,
      pageIndex: newPage - 1,
    });

  return (
    <div className="TableConfirmationBlock" style={{ marginBottom: '30px' }}>
      <h2>{title}</h2>

      <QboLink
        sx={{ fontSize: '18px', fontWeight: '500', marginBottom: '20px', display: 'block' }}
        onClick={() => {
          setVisible(!visible);
        }}>
        {visible ? 'Hide the list' : 'See the list'}
      </QboLink>

      {visible && (
        <>
          <QboSimpleDataTable sx={{ width: '100%' }} rows={paginatedList} header={headers} />
          {showPagination && (
            <Pagination
              className="TableConfirmationBlock__pagination"
              count={Math.ceil(list.length / pagination.pageSize)}
              page={pagination.pageIndex + 1}
              onChange={handleChangePage}
              size="medium"
            />
          )}
        </>
      )}
    </div>
  );
}

TableConfirmationBlock.propTypes = {
  title: PropTypes.string,
  headers: PropTypes.arrayOf(PropTypes.object),
  list: PropTypes.array,
};

TableConfirmationBlock.defaultProps = {
  title: '',
  headers: [],
  list: [],
};
